import {
  Add_sales_Data_from_Excel,
  Add_Stages,
  Delete_Stages,
  Get_All_Stages,
  Get_Error,
  Get_One_Stage_to_get_type,
  Get_One_Stages,
  Update_One_Stages,
} from '../Types';

const intial = {
  stage: [],
  updatestage: [],
  getstagetogetype: [],
  loading: true,
};

const Stages_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_Stages:
      return {
        ...state,
        stage: action.payload,
        loading: false,
      };
    case Add_sales_Data_from_Excel:
      return {
        ...state,
        stage: action.payload,
        loading: false,
      };
    case Get_All_Stages:
      return {
        ...state,
        stage: action.payload,
        loading: false,
      };

    case Delete_Stages:
      return {
        ...state,
        stage: action.payload,
        loading: false,
      };

    case Get_One_Stages:
      return {
        ...state,
        stage: action.payload,
        loading: false,
      };

    case Update_One_Stages:
      return {
        ...state,
        updatestage: action.payload,
        loading: false,
      };
    case Get_One_Stage_to_get_type:
      return {
        ...state,
        getstagetogetype: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        stagetype: action.payload,
      };
    default:
      return state;
  }
};

export default Stages_Reducer;
